import { useQuery } from 'react-query';

import api from '@root/api';

export default function useGetGenerationsUsage(enabled, filters) {
  return useQuery(['usage.generationsUsage', filters], () => api.usage.getGenerationsUsage(filters), { enabled, refetchOnMount: 'always' });
}
